export const SET_DATA_IDENTIFICATION_TYPES = "[IDENTIFICATION_TYPES] SET_DATA_IDENTIFICATION_TYPES";
export const SET_DATA_IDENTIFICATION_CODE_TYPES =
  "[IDENTIFICATION_CODE_TYPES] SET_DATA_IDENTIFICATION_CODE_TYPES";
